// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__145Wz","title":"HeroContent_title__PJ76v","description":"HeroContent_description__UQ3uN","control":"HeroContent_control__ag9Ph"};